fragment TrainingComplianceCellFields on TrainingComplianceCell {
  moduleId
  status
  dueOn
  passedAt
  expiresOn
  bestScore
}
